module.exports = require("@samvera/clover-iiif");